export enum SiglaMomentoDisparoRegraEtiquetaJudicial {
    PROCESSO_CRIACAO_PROCESSO_JUDICIAL = 'PROCESSO_CRIACAO_PROCESSO_JUDICIAL_INTEGRACAO',
    INTIMACAO_CRIACAO = 'INTIMACAO_CRIACAO_INTEGRACAO',
}
